module.exports = __webpack_public_path__ + "static/media/imagem_login.2cc98741.jpeg";